import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import * as Constants from "../../constants/urls";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loading from "../Loading/Loading";
import moment from "moment-jalaali";

export default function UserInfo() {
    const username = useParams().username;
    const [data, setData] = useState();
    const [cookies, setCookie, removeCookie] = useCookies();

    const orderStatus = [
        'ثبت سفارش',
        'آماده سازی',
        'پایان آماده سازی',
        'بررسی سفارش',
        'بسته بندی',
        'پرداخت نشده',
        'کنسل شده',
        'پرداخت شده',
        'ارسال شده',
    ]


    async function getData() {
        const url = Constants.apiUrl + "/api/user/info";
        axios
            .post(url, { username: username }, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((r) => {
                setData(r.data);
            })
            .catch((e) => {
                if (e.response.status == 403) {
                    // window.location = "403";
                }
            });
    }
    useEffect(() => {
        getData();
    }, [])

    return (<>
        <div className="continer-fluid">
            <div className="text-center py-4" style={{ fontSize: "20px" }}>
                {
                    (data && data.user) ? <strong>
                        {
                            data.user.name
                        }

                    </strong> : <strong>----</strong>
                }
            </div>
            <div className="row" style={{ direction: "rtl" }}>
                <div className="col-md-6 border rounded text-center p-4 d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                    <a href={Constants.panelUrl + "/order?username=" + username} target="_blank" className="text-black" style={{ color: "#000" }}>
                        <h3>تعداد و مبلغ سفارش</h3>
                        <br />
                        {data ? <div style={{ justifyContent: "center", direction: "ltr", fontSize: "20px" }} className="d-flex mt-2">
                            <strong>{data.orderCount}</strong>
                            <strong className="mx-2 text-danger"> / </strong>
                            <strong>{data.orderPrice / 1000} k </strong>
                        </div> : <h1>----</h1>}


                    </a>
                </div>
                <div className="col-md-6 border rounded text-center p-4 d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                    <div>
                        <h3>تاریخ آخرین سفارش</h3>
                        <br />

                        {(data && data.lastOrder) ? <div style={{ justifyContent: "center", direction: "ltr", fontSize: "20px" }} className="  mt-2">
                            <strong className="my-1">{moment(data.lastOrder.date * 1000).format('jYYYY/jM/jD ')}</strong>
                            <br />
                            <br />

                            <strong className="text-danger my-1">{orderStatus[data.lastOrder.stat - 1]} </strong>
                            <br />
                            <br />

                            <strong className="my-1">{data.lastOrder.deliverMode == 14 ? data.lastOrder.postReferenceID : data.lastOrder.order_info.tracking_code} </strong>
                        </div> : <h1>----</h1>}
                    </div>
                </div>

                <div className="col-md-6 border rounded text-center p-4 d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                    <div>
                        <h3>تعداد و مبلغ کلاس</h3>
                        <br />
                        {data ? <div style={{ justifyContent: "center", direction: "ltr", fontSize: "20px" }} className="d-flex mt-2">
                            <strong>{data.classCount}</strong>
                            <strong className="mx-2 text-danger"> / </strong>
                            <strong>{data.classPrice / 1000} k </strong>
                        </div> : <h1>----</h1>}


                    </div>
                </div>


                <div className="col-md-6 border rounded text-center p-4 d-flex" style={{ alignItems: "center", justifyContent: "center" }}>
                    <div style={{ width: "100%" }}>
                        <h3> لیست کلاس ها </h3>
                        <br />
                        {(data && data.userClass) ? <div style={{ justifyContent: "center", direction: "ltr", fontSize: "20px", maxHeight: "100px", overflowY: "scroll" }} className=" mt-2">
                            {
                                data.userClass.map((item) => (
                                    <div className="border py-2 my-2 rounded" style={{ width: "100%", textAlign: "center" }}>
                                        <strong>
                                            {item.name}
                                        </strong>
                                    </div>
                                ))

                            }
                        </div> : <h1>----</h1>}


                    </div>
                </div>
            </div>

            <div className="text-center py-4" style={{ fontSize: "20px" }}>

                {
                    (data && data.user) ? <h2 className="text-success">
                        <a target="_blank" href={Constants.oldAdminUrl + "/usersstock/admin?UsersStock[username]=" + username} className="text-success py-4" style={{ fontSize: "20px" }}>

                            موجودی :
                            {
                                data.user.user_stock
                            }
                        </a>

                    </h2> : <strong>----</strong>
                }
            </div>
        </div>
    </>)
}